import { useQuery } from '@tanstack/react-query';
import { usePermissions } from '@/contexts/PermissionsContext';
import { BackupStatusDeniedError, backupStatusService } from '@/services/backupStatusService';

export const BACKUP_STATUS_KEY = ['ops-backup-status'] as const;

/**
 * État des sauvegardes pour le voyant : actualisé toutes les 60 s (le PC pousse un relevé toutes les 15 min), à l'onglet visible seulement.
 * Désactivé hors super admin : aucune requête pour les autres utilisateurs. Un échec est réessayé une fois (3 s) ; si le second échoue,
 * isError passe à vrai (voyant « inconnu ») et la dernière donnée reste dans `data`. 401 ou 403 : on arrête (voyant masqué).
 */
export function useBackupStatus() {
  const { isSuperAdmin, isLoading } = usePermissions();
  const enabled = !isLoading && isSuperAdmin;

  const query = useQuery({
    queryKey: BACKUP_STATUS_KEY,
    queryFn: () => backupStatusService.get(),
    enabled,
    staleTime: 30_000,
    refetchInterval: q => (q.state.error instanceof BackupStatusDeniedError ? false : 60_000),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    retry: (count, error) => !(error instanceof BackupStatusDeniedError) && count < 1,
    retryDelay: 3000,
  });

  return {
    enabled,
    data: query.data,
    isError: query.isError,
    denied: query.error instanceof BackupStatusDeniedError,
    dataUpdatedAt: query.dataUpdatedAt,
  };
}
